module.exports = __webpack_public_path__ + "img/learning-background.9c9e3f74.png";